import classNames from 'classnames';
import {
  addDays,
  endOfMonth,
  endOfWeek,
  format,
  isSameDay,
  isSameMonth,
  startOfMonth,
  startOfWeek,
} from 'date-fns';
import { FC } from 'react';
import { ICalendarEvent } from '../../types';
import EventButtons from './EventButtons';

interface IWeekRowProps {
  date: Date;
  selectedDate: Date;
  selectedEventId: number;
  activeDate: Date;
  onEventClick: (date: Date) => (eventId: number | null) => void;
  events: ICalendarEvent[];
}

const WeekRow: FC<IWeekRowProps> = ({
  date,
  selectedDate,
  activeDate,
  events,
  onEventClick,
  selectedEventId,
}) => {
  let currentDate = date;
  const week = [];
  for (let day = 0; day < 7; day++) {
    const cloneDate = currentDate;
    const calEvents = events.filter(calEvent =>
      isSameDay(new Date(calEvent.date), cloneDate),
    );
    week.push(
      <div className="event-calendar__day-height">
        <div
          key={day}
          className={classNames('event-calendar__day-cell', {
            'event-calendar__inactive-day': !isSameMonth(
              currentDate,
              activeDate,
            ),
            'event-calendar__today': isSameDay(currentDate, new Date()),

            'event-calendar__selected-day': isSameDay(
              currentDate,
              selectedDate,
            ),
          })}
        >
          <div className="event-calendar__day-number">
            {format(currentDate, 'd')}
          </div>
          <EventButtons
            events={calEvents}
            onEventClick={onEventClick(cloneDate)}
            selectedEventId={selectedEventId}
          />
        </div>
      </div>,
    );
    currentDate = addDays(currentDate, 1);
  }
  return <div className="event-calendar__week-row">{week}</div>;
};

interface IProps {
  activeDate: Date;
  onEventClick: (date: Date) => (eventId: number | null) => void;
  selectedDate: Date;
  selectedEventId: number;
  events: ICalendarEvent[];
}

const CalendarBody: FC<IProps> = ({
  selectedDate,
  activeDate,
  events,
  onEventClick,
  selectedEventId,
}) => {
  const startOfTheSelectedMonth = startOfMonth(activeDate);
  const endOfTheSelectedMonth = endOfMonth(activeDate);
  const startDate = startOfWeek(startOfTheSelectedMonth, { weekStartsOn: 1 });
  const endDate = endOfWeek(endOfTheSelectedMonth);

  let currentDate = startDate;

  const allWeeks = [];

  while (currentDate <= endDate) {
    allWeeks.push(
      <WeekRow
        key={currentDate.getTime()}
        date={currentDate}
        selectedDate={selectedDate}
        activeDate={activeDate}
        onEventClick={onEventClick}
        events={events}
        selectedEventId={selectedEventId}
      />,
    );
    currentDate = addDays(currentDate, 7);
  }

  return <div className="event-calendar__body">{allWeeks}</div>;
};

export default CalendarBody;
